import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/parts-catalog/shipping-returns")({
  head: () => pageHead({ title: 'Shipping & Returns', description: 'Shipping and return policy for RV parts orders at Rex & Sons RVs.', path: '/parts-catalog/shipping-returns' }),
  beforeLoad: () => {
    throw redirect({ href: "/parts-catalog/page/shipping-returns" });
  },
});
